import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Link from '~/components/Link';
import Form from '~/components/Form';
import * as S from '~/components/Form/styles';
import Input from '~/components/Form/Input';
import routesPath from '~/constants/routes';
import FormConfig from '~/pages/ChangePassword/components/FormConfig';
import DefaultLayout from '~/pages/_layouts/DefaultLayout';
import { languageOptions } from '~/utils/languageOptions';
import { FoldedMenu } from '~/components';

export default function ChangePassword() {
  const { t } = useTranslation();
  const { code } = useParams();

  return (
    <DefaultLayout>
      <FormConfig code={code || null}>
        {props => {
          // eslint-disable-next-line react/prop-types
          const { isSubmitting, handleSubmit } = props;
          return (
            <S.FormContainer width={30}>
              <Form hasWidth={100} onSubmit={handleSubmit}>
                <S.Logo />
                <S.FormTitle>{t('loginIntoAccount')}</S.FormTitle>

                <Input
                  icon="lock"
                  type="password"
                  selector="password"
                  label={t('password')}
                  placeholder={t('password')}
                  formikProps={props}
                />

                <Input
                  icon="lock"
                  type="password"
                  selector="passwordConfirmation"
                  label={t('confirmPasswordLabel')}
                  placeholder={t('confirmPassword')}
                  formikProps={props}
                />

                <S.Aligner>
                  <S.SubmitButton type="submit" disabled={isSubmitting}>
                    {t('changePassword')}
                  </S.SubmitButton>
                </S.Aligner>

                <S.Return>
                  <Link to={routesPath.login}>{t('loginIntoAccount')}</Link>
                </S.Return>
              </Form>
            </S.FormContainer>
          );
        }}
      </FormConfig>
      <FoldedMenu label={t('languageId')} options={languageOptions()} />
    </DefaultLayout>
  );
}
